class CountryLanguageDropdown {
    constructor(wuplus_countryDropdown, wuplus_languageDropdown) {
        if (!wuplus_countryDropdown || !wuplus_languageDropdown)
            throw new Error("Wuplus Country and Language is required");

        this.countryDropdown = wuplus_countryDropdown;
        this.languageDropdown = wuplus_languageDropdown;
     
        this.countryTrigger = this.countryDropdown.querySelector("[data-wu-plus-countries-trigger]");
        this.countryList = this.countryDropdown.querySelector("[data-wu-plus-countries-dropdown-list]");
        this.languageTrigger = this.languageDropdown.querySelector("[data-wu-plus-language-trigger]");
        this.languageList = this.languageDropdown.querySelector("[data-wu-plus-language-dropdown-list]");
        this.languageListItems = this.languageDropdown.querySelectorAll(".wuplus-language-list-items");
        this.countryMoreBtn = this.countryDropdown.querySelectorAll(".country-trigger .b-language-dropdown");
        this.languageMoreBtn = this.languageDropdown.getElementsByClassName("language-arrow-icon");
        this.countryListitems = this.countryDropdown.querySelectorAll(".wuplus_countries");
        this.defaultCountryTitle = this.countryDropdown.querySelector('[data-country-name-selected]')
        this.countryFlag = this.countryDropdown.querySelector('[data-country-code-selected]')
        this.defaultCountryCode = this.countryFlag.getAttribute('data-default-country-code')
        this.defaultCountryTitle = this.countryDropdown.querySelector('[data-country-name-selected]')
        this.selectedLanguage =this.languageDropdown.querySelector('[data-selected-language]')
        this.init();
    }

    init() {

        this.listeners();

        this.countryTrigger.addEventListener("click", () => {
            this.countryList.classList.contains('d-none') ? this.openList(this.countryList, this.countryMoreBtn, this.languageList) : this.closeList(this.countryList, this.countryMoreBtn)
        });

        this.languageTrigger.addEventListener("click", () => {
            this.languageList.classList.contains('d-none') ? this.openList(this.languageList, this.languageMoreBtn, this.countryList) : this.closeList(this.languageList, this.languageMoreBtn)
        });
        window.addEventListener('click', e => {
            if (e.target.classList && e.target.classList.value && e.target.classList.value.indexOf('b-flag-select') === -1) {
                this.closeList(this.countryList, this.countryMoreBtn)
                this.closeList(this.languageList, this.languageMoreBtn)
            }
        })
    }
    listeners() {

         for (let i = 0; i < this.countryListitems.length ; i++) {
                this.countryListitems[i].addEventListener("click", () => {
                    this.getCountrySelected(this.countryListitems[i])
                });

                this.languageListItems[i].addEventListener("click", () => {
                    this.getLanguageSelected(this.languageListItems[i])
                });
            }
    }

    getCountrySelected(wuplus_country_item) {

        let selectedCountryTitle = wuplus_country_item.getAttribute('data-country-title')
        let selectedCountryCode = wuplus_country_item.getAttribute('data-country-code')
        this.resetLanguageList();
        this.setCountryFlag(selectedCountryCode)
        this.defaultCountryTitle.innerHTML = selectedCountryTitle
        this.filterLanguageList(selectedCountryCode)
        this.closeList(this.countryList, this.countryMoreBtn)
        this.defaultCountryCode = selectedCountryCode
        this.setContinueButtonLink( this.defaultCountryCode ,'en')
    }

    setCountryFlag(selectedCountryCode){

        this.countryFlag.classList.remove(this.defaultCountryCode)
        this.countryFlag.classList.add(selectedCountryCode)
        this.countryFlag.setAttribute('data-default-country-code', selectedCountryCode)
    }

    filterLanguageList(countryCode) {

        for (let i = 0; i < this.languageListItems.length ; i++) {
            if (this.languageListItems[i].getAttribute('data-country') == countryCode || this.languageListItems[i].getAttribute('data-country') == "global") {
                this.languageListItems[i].classList.add('d-block')
                this.languageListItems[i].classList.remove('d-none')
            } else {
                this.languageListItems[i].classList.add('d-none')
                this.languageListItems[i].classList.remove('d-block')
            }
        }
    }

    resetLanguageList() {

        for (let i = 0; i < this.languageListItems.length; i++) {
            if (this.languageListItems[i].getAttribute('data-country') == "global") {
                this.languageListItems[i].classList.add('d-block')
                this.languageListItems[i].classList.remove('d-none')
            } else {
                this.languageListItems[i].classList.add('d-none')
                this.languageListItems[i].classList.remove('d-block')
            }
        }
        this.selectedLanguage.innerHTML = "English"
    }

    openList(dropdownList, moreButton, closedropdown) {

        dropdownList.classList.add('d-block')
        moreButton && moreButton[0].classList.add("down");
        dropdownList.classList.remove('d-none')
        closedropdown.classList.remove('d-block')
        closedropdown.classList.add('d-none')
    }

    closeList(dropdownList, moreButton) {
        dropdownList.classList.remove('d-block')
        moreButton && moreButton[0].classList.remove("down");
        dropdownList.classList.add('d-none')
    }

    getLanguageSelected(wuplusLanguageItem) {

        let selectedLanguageTitle = wuplusLanguageItem.getAttribute('data-language-name')
        let selectedLanguageCode = wuplusLanguageItem.getAttribute('data-language')
        document.querySelector('[data-selected-language]').innerHTML = selectedLanguageTitle
        this.closeList(this.languageList, this.languageMoreBtn)
        this.setContinueButtonLink(this.defaultCountryCode ,selectedLanguageCode)
    }

    setContinueButtonLink(selectedCountryCode, selectedLanguageCode) {
     
        let continueButton = document.querySelector('.continue-dropdown-btn');
        let hrefAttr = continueButton.getAttribute('href')
        let hrefAttrSplit = hrefAttr.split('/');
        hrefAttrSplit[1] = selectedCountryCode;
        hrefAttrSplit[2] = selectedLanguageCode;
        continueButton.setAttribute('href', hrefAttrSplit.join('/'))
    }
}

function intializeCountryLanguageDropdown() {
    let wuplus_countryDropdown = document.querySelectorAll("[data-wu-plus-countries-dropdown-box]");
    let wuplus_languageDropdown = document.querySelectorAll("[data-wu-plus-language-dropdown-box]");

    if (wuplus_countryDropdown.length > 0 && wuplus_languageDropdown.length > 0) {
        for (
            let i = 0; i < wuplus_countryDropdown.length && i < wuplus_languageDropdown.length; i++
        ) {
            new CountryLanguageDropdown(
                wuplus_countryDropdown[i],
                wuplus_languageDropdown[i]
            );
        }
    }
}

if (/complete|interactive|loaded/.test(document.readyState)) {
    intializeCountryLanguageDropdown();
} else {
    intializeCountryLanguageDropdown();
}